module.exports = __webpack_public_path__ + "static/media/BLUSH_3241.869f54f4.jpg";